// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.new-user-selection-card {
  margin: 1rem;
  border: 1px solid #ccc;
  padding: 4.5rem 2rem;
  border-radius: 8px;
  cursor: pointer;
  background: white;
}
.new-user-selection-card .vertical {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 6rem;
}
.new-user-selection-card .vertical .card-title {
  max-width: 30rem;
  text-align: center;
}
.new-user-selection-card .horizontal {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.new-user-selection-card .card-icon {
  transform: scale(3.2);
  transform-origin: center;
  margin-top: 3rem;
  margin-bottom: 5rem;
}
.new-user-selection-card .horizontal .card-icon {
  margin-right: 3.5rem;
  margin-left: 3.5rem;
  margin-bottom: 3rem;
}
.new-user-selection-card .card-title {
  margin-bottom: 0.05rem;
  font-size: 36px;
  font-weight: bold;
}
.new-user-selection-card .card-description {
  font-size: 18px;
}
.new-user-selection-card .horizontal .card-content {
  display: flex;
  flex-direction: column;
  padding-left: 27px;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Cards/NewUserSelectionCard/index.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,sBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AACF;AACE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,oBAAA;AACJ;AAAI;EACE,gBAAA;EACA,kBAAA;AAEN;AAEE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,qBAAA;EACA,wBAAA;EACA,gBAAA;EACA,mBAAA;AADJ;AAIE;EACE,oBAAA;EACA,mBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,eAAA;AAJJ;AAOE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;AALJ","sourcesContent":[".new-user-selection-card {\n  margin: 1rem;\n  border: 1px solid #ccc;\n  padding: 4.5rem 2rem;\n  border-radius: 8px;\n  cursor: pointer;\n  background: white;\n\n  .vertical {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-bottom: 6rem;\n    .card-title {\n      max-width: 30rem;\n      text-align: center;\n    }\n  }\n\n  .horizontal {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n  }\n\n  .card-icon {\n    transform: scale(3.2);\n    transform-origin: center;\n    margin-top: 3rem;\n    margin-bottom: 5rem;\n  }\n\n  .horizontal .card-icon {\n    margin-right: 3.5rem;\n    margin-left: 3.5rem;\n    margin-bottom: 3rem;\n  }\n\n  .card-title {\n    margin-bottom: 0.05rem;\n    font-size: 36px;\n    font-weight: bold;\n  }\n\n  .card-description {\n    font-size: 18px;\n  }\n\n  .horizontal .card-content {\n    display: flex;\n    flex-direction: column;\n    padding-left: 27px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
